import React, { memo } from "react";
import {
  IconButton,
  Tooltip,
  Fade,
  Box,
  Typography,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import "./ControlButton.css";

interface ControlButtonProps {
  title: string;
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
  icon: React.ReactNode;
}

const ControlButton = memo(
  ({
    title,
    active = false,
    disabled = false,
    onClick,
    icon
  }: ControlButtonProps) => {
    const className = `zoom-control-btn ${active ? "active" : ""} ${
      disabled ? "disabled" : ""
    }`;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
      <Box className="zoom-control-button">
        <Tooltip title={title} arrow TransitionComponent={Fade} placement="top">
          <IconButton
            className={className}
            onClick={onClick}
            disabled={disabled}
          >
            {icon}
          </IconButton>
        </Tooltip>
        {!isMobile && (
          <Typography variant="caption" className="zoom-control-btn-label">
            {title}
          </Typography>
        )}
      </Box>
    );
  }
);

export default ControlButton;
